import { GeneratableSelectInputOptions } from 'shared-ui/lib/components/customs/form/SelectInput';
import { UserLevel } from '../hooks/use-can';

// Kutsuttaessa ja tasoa muutettaessa masteria ei voi myöntää (vrt. backendin
// listOfAssignableUserLevels).
export const assignableUserLevels: UserLevel[] = [
  UserLevel.ADMIN,
  UserLevel.EDITOR,
  UserLevel.BASIC,
];

// Labelit ovat shared-ui:n UserLevel-nimiavaruuden käännösavaimia; SelectInput
// kääntää ne i18n:llä.
export const getAssignableUserLevelOptions =
  (): GeneratableSelectInputOptions['props']['options'] =>
    assignableUserLevels.map((value) => ({
      value,
      label: `UserLevel:${value}`,
    }));
